import React from "react";
import "./Main.css";
import Donors from "../Donors/Donors";
import {
    getBines,
    getCurrency,
    getDatas,
    getUtms,
    hidePage,
    setTable,
    showPage,
    updateCartNumber
} from "../extras/Actions";
import niños from "../../resources/mama.png";
import Gifts from "../Gifts/Gifts";
import Guirnalda from "../../img/Girnalda.png";
import FondoCopos from "../Copitos/Copitos";
import mama from "../../img/mamá.png";
export default class Dashboard extends React.Component{

    componentDidMount() {
        setTable()
        hidePage()
        getBines()
        getDatas()
        updateCartNumber()
        getUtms();
        if (!window.location.href.includes("gifts")){
            document.querySelector(".gifts-container").style.paddingTop = "40px"
            document.querySelector(".gift-title").style.paddingTop = "40px"
        }
        getCurrency()
        setTimeout(showPage,3000)
    }

    render() {
        return (
            <div className="main">
                <div className="main_banner">
                    <img src={niños} alt=""/>
                    {/*<img src={Guirnalda} className={"guirnalda"}/>*/}
                </div>
                <div className="main-container">
                    <div className="progress">
                        <h1 className={"table-name"}> </h1>
                        <div className="progress-bar ">
                            <div className="visual-progress">
                                <div className="filled-progress">
                                    <div className="dialog">
                                        <div className="dialog-text">

                                        </div>
                                        <div className="triangulo">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="goal ">
                            Meta $3,500,000.00
                        </div>
                        <div className="legend">
                            Todo bebé merece más que sobrevivir. Merece estar a salvo, alimentado y amado. Merece la oportunidad de crecer, reír y aprender. Merece un futuro. <br/><br/> Este futuro tú puedes dárselo con un regalo. Tu regalo se convierte en atención, protección y salud para la niñez en México y en las emergencias globales.
                        </div>
                    </div>
                    <Gifts/>
                </div>

                <div className="main_content">
                    <div className="text-container">
                        <div className="text">
                            <b className="title red">¿Por qué El Regalo Más Valioso?</b>
                            <p>
                                <b>¿Por qué el regalo más valioso?</b> Cada regalo que ves aquí se transforma en
                                acciones reales de Save the Children: <b>atención a familias afectadas por las
                                inundaciones en Veracruz y Puebla, apoyo a la primera etapa de vida en nuestras
                                comunidades y también como respuesta ante crisis que no pueden esperar, como Gaza.</b>
                                En 2026 queremos priorizar a quienes más riesgo
                                tienen de no sobrevivir sus primeros días: las mamás y los bebés.
                            </p>
                            <b className="title red">
                                ¿Por qué mamás y bebés?
                            </b>
                            <p>
                                Porque el primer respiro no siempre es seguro. Estos últimos años, las niñas y los niños
                                han nacido en contextos de guerra,
                                desastres o pobreza. Las y los bebés nacen sin agua limpia, sin electricidad, y sus
                                mamás no saben si sus hijas o hijos tendrán oportunidad de sobrevivir.
                                A nivel global, <b>2.4 millones de recién nacidos mueren cada año por causas prevenibles
                                y cada 2 minutos muere una mujer por complicaciones del embarazo o parto.</b>
                                Con algo tan sencillo como un kit de parto limpio, atención médica o un espacio
                                seguro para lactar, podemos cambiar esa historia. <b>¡Gracias por darle a la niñez un
                                futuro lleno de esperanza y posibilidades!</b>
                            </p>
                        </div>
                        <div className="main-image">
                            <img src={mama} alt=""/>
                        </div>
                    </div>
                    <a href="#gifts" className="gifts-link">
                        Elige un regalo que cuide a una mamá y a su bebé
                    </a>
                    <div className="disclaimer">
                        Al seleccionar un regalo de este catálogo, estás realizando una donación a Save the Children
                        que apoya una o más acciones específicas de diferentes programas. Cada regalo en este catálogo
                        representa recursos, servicios o apoyo para programas ofrecidos por Save the Children en México,
                        y pueden cambiar debido a consideraciones ambientales, programáticas y económicas. Tus
                        donaciones se utilizarán para brindar ayuda donde más se necesite dentro de las áreas
                        programáticas especificadas.
                    </div>
                </div>
                <div className="donors-box">
                    <h4 className="red donors-header">
                        Participantes
                    </h4>
                    <Donors/>

                </div>
            </div>
        );
    }
}